<template>
  <transition name="fade">
    <v-app>
      <keep-alive include="CommerceOrders">
        <router-view />
      </keep-alive>
    </v-app>
  </transition>
</template>

<script>
export default {
  name: "App",
  props: {
    source: String,
  },
  data() {
    return {
      drawer: null,
      drawerRight: null,
      right: false,
      left: false,
    };
  },
};
</script>
